var map = {
	"./behind-the-scenes-01.json": 4073,
	"./behind-the-scenes-02.json": 9500,
	"./behind-the-scenes-03.json": 3343,
	"./behind-the-scenes-04.json": 4578,
	"./behind-the-scenes-05.json": 7933,
	"./behind-the-scenes-06.json": 6240,
	"./behind-the-scenes-07.json": 2531,
	"./behind-the-scenes-08.json": 1238,
	"./behind-the-scenes-09.json": 5233,
	"./festival-2025-highlight-01.json": 3906,
	"./festival-2025-highlight-02.json": 9155,
	"./festival-2025-highlight-03.json": 6128,
	"./festival-2025-highlight-04.json": 2233,
	"./festival-2025-highlight-05.json": 1422,
	"./festival-2025-highlight-06.json": 1535,
	"./festival-2025-highlight-07.json": 5468,
	"./festival-2025-highlight-08.json": 4053,
	"./festival-2025-highlight-09.json": 970,
	"./festival-2025-highlight-10.json": 9440,
	"./festival-2025-highlight-11.json": 9779,
	"./festival-2025-highlight-12.json": 5522,
	"./festival-2025-highlight-13.json": 4957,
	"./festival-2025-highlight-14.json": 4076,
	"./festival-2025-highlight-15.json": 1215,
	"./festival-2025-highlight-16.json": 3886,
	"./festival-2025-highlight-17.json": 8073,
	"./festival-2025-highlight-18.json": 6264,
	"./festival-2025-highlight-19.json": 7675,
	"./festival-2025-highlight-20.json": 7867,
	"./festival-2025-highlight-21.json": 680,
	"./festival-2025-highlight-22.json": 4421,
	"./festival-2025-highlight-23.json": 3978,
	"./festival-2025-highlight-24.json": 3447,
	"./festival-2025-highlight-25.json": 1364,
	"./festival-2025-highlight-26.json": 3793,
	"./festival-2025-highlight-27.json": 86,
	"./festival-2025-highlight-28.json": 4643,
	"./festival-2025-highlight-29.json": 2784,
	"./festival-2025-video-01.json": 7359,
	"./festival-2025-video-02.json": 9502,
	"./festival-2025-video-03.json": 8089,
	"./festival-2025-video-04.json": 3904,
	"./poetry-in-motion-01.json": 9691,
	"./poetry-in-motion-02.json": 9578,
	"./poetry-in-motion-03.json": 2661,
	"./poetry-in-motion-04.json": 4484,
	"./youtube-01.json": 9014,
	"./youtube-02.json": 2951,
	"./youtube-03.json": 4356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3820;